// src/utils/theme.js

export const theme = {
  colors: {
    bg: "#F7F8FC",
    surface: "#FFFFFF",
    card: "#FFFFFF",
    border: "#E4E7F0",
    accent: "#3D7EFF",
    accentSoft: "#EBF1FF",
    green: "#16A349",
    greenSoft: "#ECFDF5",
    red: "#DC2626",
    redSoft: "#FEF2F2",
    amber: "#D97706",
    amberSoft: "#FFFBEB",
    purple: "#7C3AED",
    purpleSoft: "#F5F3FF",
    text: "#111827",
    muted: "#6B7280",
    dim: "#E5E7EB",
  },
  dark: {
    bg: "#080B14",
    surface: "#0E1220",
    card: "#141826",
    border: "#1E2540",
    accent: "#3D7EFF",
    green: "#22D97A",
    greenDim: "#0D2E1C",
    amber: "#F5A623",
    red: "#FF5C5C",
    text: "#EDF0FA",
    muted: "#5A6080",
    dim: "#1E2540",
  },
  fonts: {
    sans: "'DM Sans', sans-serif",
    mono: "'DM Mono', monospace",
  },
  shadows: {
    soft: "0 4px 20px rgba(0,0,0,0.05)",
    accent: "0 4px 12px rgba(61, 126, 255, 0.3)",
  }
};
